/*
 * File: /src/router/routes/campaigns.js
 * Created Date: Sunday May 26th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 26th May 2019 11:58:32 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const CampaignsList = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignList.vue'
  );

const CampaignSend = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignSend.vue'
  );

const EmailCampaignReport = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignEmailReport.vue'
  );

const SmsCampaignReport = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignSmsReport.vue'
  );

const CampaignPostcardReport = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignPostcardReport.vue'
  );

const CampaignsChat = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignChatList.vue'
  );
const CampaignsChatEdit = () =>
  import(
    /* webpackChunkName: "Campaigns" */ 'src/components/Dashboard/Views/Campaigns/CampaignChatEdit.vue'
  );

export const campaignRoutes = [
  {
    path: 'campaigns/list',
    name: 'Listing Campaigns',
    component: CampaignsList,
  },
  {
    path: 'campaigns/send/:campaignType/:id?',
    name: 'Send Email Campaign',
    component: CampaignSend,
  },

  {
    path: 'campaigns/email-report/:id',
    name: 'Email Campaign Report',
    component: EmailCampaignReport,
  },

  {
    path: 'campaigns/sms-report/:id',
    name: 'SMS Campaign Report',
    component: SmsCampaignReport,
  },

  {
    path: 'campaigns/postcard-report/:id',
    name: 'Postcard Campaign Report',
    component: CampaignPostcardReport,
  },

  {
    path: 'campaigns/chat',
    name: 'Listing Chat Campaigns',
    component: CampaignsChat,
  },
  {
    path: 'campaigns/chat/edit/:id',
    name: 'Edit Chat Campaigns',
    component: CampaignsChatEdit,
  },
];
